import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { TagEl } from "../tag";
import { TagSize, TagTheme } from "../tag/types";
import { InputEl } from "../input";
import { TagInputSearchMode } from "./types";
import tagStyle from "./tag.inline.styl";
function TagMenu() {
  var _a;
  if (this.state.menuSections === null) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: this.state.isMenuOpen,
      "prevent-close-selectors": [`.mp-tag-input-input-wrapper`]
    },
    on: {
      change: (ev) => this.handleTagMenuChange(ev)
    },
    props: {
      positionParent: this.attr(`search-mode`) === TagInputSearchMode.Hashtag ? (_a = this.state.searchInputEl) == null ? void 0 : _a.searchInput : this
    },
    style: this.getDropMenuStyles()
  }, this.state.isMenuOpen && /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".mp-tag-input-tag-menu",
    attrs: {
      elref: `mpTagInputTagMenu`,
      "search-filter": this.getStagedTagSearch() || ``,
      "empty-message": `No results`,
      ...this.attr(`mp-items-menu-attrs`)
    },
    props: {
      sections: this.getMenuSections(),
      keydownProxyEl: this.state.searchInputEl,
      sectionsFromInputFn: this.state.sectionsFromInputFn
    },
    on: {
      clickItem: (ev) => this.handleClickTagItem(ev)
    }
  }));
}
export function template() {
  const alwaysShowClear = Boolean(
    this.attr(`show-clear`) && (this.state.tagMap.size > this.attr(`min-tags`) || this.state.inputText)
  );
  const tagEls = /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("style", null, tagStyle), Array.from(this.state.tagMap.values()).map((tag, index) => {
    return /* @__PURE__ */ jsx(TagEl, {
      sel: ".mp-tag-input-tag",
      class: {
        multiline: this.attr(`multiline`)
      },
      attrs: {
        elref: `mpTagInputTag`,
        tabindex: 0,
        removable: this.canRemoveTag(tag),
        size: TagSize.Small,
        "tag-name": tag.label,
        theme: this.state.isFocused ? TagTheme.Light : TagTheme.Secondary,
        "data-index": index,
        ...tag.attrs
      },
      key: `tag-${tag}`,
      on: {
        remove: () => this.canRemoveTag(tag) && this.removeTag(tag),
        keydown: (ev) => this.handleTagKeyDown(ev, { tag, index }),
        click: (ev) => ev.stopPropagation(),
        focus: (ev) => this.handleTagFocus(ev),
        blur: (ev) => this.handleTagBlur(ev)
      }
    });
  }));
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-container"
  }, /* @__PURE__ */ jsx(InputEl, {
    sel: ".mp-tag-input-search-input",
    attrs: {
      ...this.getInputAttrs(),
      elref: `searchInput`,
      placeholder: this.getPlaceholder(),
      "always-show-clear": alwaysShowClear
    },
    params: {
      prefixRenderer: () => tagEls,
      suffixRenderer: this.state.suffixRenderer
    },
    props: {
      value: this.state.inputText
    },
    on: {
      focus: () => this.handleInputFocus(),
      blur: () => this.handleInputBlur(),
      input: (ev) => this.changeInputText(ev.target.value),
      clear: (ev) => this.handleClearInput(ev),
      keydown: (ev) => this.handleInputKeyDown(ev)
    },
    hook: {
      insert: (vnode) => this.handleSearchInputInsert(vnode)
    }
  }), TagMenu.call(this));
}
